import keyMirror from "keymirror";

const ActionTypes = {
  THREAD_CREATION_REQUESTED: "SCRAPING_THREAD_CREATION_REQUESTED",
  THREAD_CREATED: "SCRAPING_THREAD_CREATED",
  IS_LOADING_THREADS: "IS_LOADING_SCRAPING_THREADS",
  TABLE_DATA_RECEIVED: "SCRAPING_THREADS_TABLE_DATA_RECEIVED",
  TABLE_DATA_REQUESTED: "SCRAPING_THREADS_TABLE_DATA_REQUESTED",
  THREAD_MODIFIED: "SCRAPING_THREAD_MODIFIED",
  SCRAPING_THREAD_STATUS_CHANGED: "SCRAPING_THREAD_STATUS_CHANGED",
};

export default ActionTypes;
